import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';


export const HeadLabel = styled('h4', { label: 'HeadLabel' })`
    display: inline-block;
    padding-right: 10px
`;

export const ErrorWrapper = styled('div', { label: 'ErrorWrapper' })`
    background-color: ${mainColors.status.error};
    color: ${mainColors.default.light};
    flex: 1 0 auto;
    font-weight: 700;
    height: max-content;
    margin: 5px 0;
    padding: 0 5px;
`;

export const HeadWrapper = styled('div', { label: 'HeadWrapper' })`
    display: flex;
`;
